import { memo } from "react";
import {
  Container,
  Nav,
  NavDropdown,
  Navbar as ReactNavbar,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { List } from "react-bootstrap-icons";

const StyledNavbar = styled(ReactNavbar)`
  padding: 0;
  z-index: 99;

  > div {
    padding: 0;
    display: flex;
    flex-direction: column;

    button {
      color: var(--primary-color);
      display: flex;
      flex-direction: column;
      margin-top: -20px;
      background: var(--bs-body-bg);
      align-self: end;
      margin-right: 10px;
      box-shadow: none !important;
      margin-bottom: -10px;
    }

    > .navbar-collapse {
      width: 100%;
      border-bottom: solid 2px var(--border-color);

      a.nav-link {
        color: var(--primary-color);
        text-transform: uppercase;
        --bs-navbar-nav-link-padding-x: 1.5rem;
        --bs-nav-link-padding-y: 1rem;
        --bs-nav-link-padding-x: 1.5rem;
        -webkit-transition: none !important;
        transition: none !important;
      }

      a:hover {
        background: var(--border-color);
      }

      a.show {
        background: var(--primary-color);
        color: var(--bs-body-bg);
      }

      a.dropdown-toggle::after {
        margin-left: 10px;
      }

      div.dropdown-menu {
        padding: 0;
        border-radius: 0;
        margin-top: 0;
        border: solid 2px var(--border-color);

        --bs-dropdown-item-padding-y: 1rem;
        --bs-dropdown-item-padding-x: 1.5rem;
        --bs-dropdown-link-hover-bg: var(--bs-body-bg);
        --bs-dropdown-link-active-bg: var(--bs-body-bg);
        --bs-dropdown-link-active-color: var(--primary-color);
      }
    }

    > .navbar-collapse.show,
    > .navbar-collapse.collapsing {
      margin-top: 10px;
      -webkit-transition: none !important;
      transition: none !important;
    }
  }
`;

const Copyright = styled.div`
  border-top: solid 2px var(--border-color);
  text-align: center;
  padding: 0.5rem 0;
`;

const MobileOnlyLinks = styled.div`
  display: block;

  @media (min-width: 992px) {
    display: none;
  }
`;

const Navbar = () => {
  return (
    <StyledNavbar expand="lg">
      <Container fluid={true}>
        <ReactNavbar.Toggle aria-controls="responsive-navbar-nav">
          <List />
        </ReactNavbar.Toggle>
        <ReactNavbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown title="Base64" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/base64">
                View All Base64 Tools
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/base64encode">
                Encode
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/base64decode">
                Decode
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/guidgenerate">
              GUID Generate
            </Nav.Link>
            <Nav.Link as={Link} to="/md5hash">
              MD5 Hash
            </Nav.Link>
            <NavDropdown title="URL" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/url">
                View All URL Tools
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/urlencode">
                Encode
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/urldecode">
                Decode
              </NavDropdown.Item>
            </NavDropdown>
            <MobileOnlyLinks>
              <Nav.Link as={Link} to="/privacypolicy">
                Privacy Policy
              </Nav.Link>
              <Nav.Link as={Link} to="/termsandconditions">
                Terms & Conditions
              </Nav.Link>
              <Nav.Link as={Link} to="/contact">
                Contact
              </Nav.Link>
              <Nav.Link href="https://domainfindr.com" target="_blank">
                DomainFindr
              </Nav.Link>
              <Nav.Link href="https://massgenerate.com" target="_blank">
                MassGenerate
              </Nav.Link>
              <Copyright>
                &copy; TOOLWEAVER {new Date().getFullYear()}
              </Copyright>
            </MobileOnlyLinks>
          </Nav>
        </ReactNavbar.Collapse>
      </Container>
    </StyledNavbar>
  );
};

export default memo(Navbar);
